export function displayUuid(uuid: string): string {
  if (uuid) {
    return uuid.substring(0, 8).toUpperCase();
  }
  return uuid;
}


export function displayStatus(status: string): string {
  if (status) {
    const words = status.split('_');
    const formatted = words.map(word => {
      const lowerCase = word.toLowerCase();
      return lowerCase[0].toUpperCase() + lowerCase.slice(1);
    });
    return formatted.join(' ');
  }
  return '';
}

export function displayString(string: string | null, length: number = 20): string {
  if (string != null) {
    if (string.length > length) {
      return (string.slice(0, length - 3) + '...');
    }
    return string;
  }
  return '-';
}

export function displayListAsString(list: string[]) {
  if (list) {
    return list.join(', ');
  }
  return '';
}

export function displayCode(string: string) {
  if (string != null) {
    return string.toLowerCase().split(' ').join('_');
  }
  return '';
}

export function displayBoolAsYesNo(bool: boolean): string {
  return bool ? 'Yes' : 'No';
}
